import React, { Component } from 'react';
import './../css/master.css';
import './../css/worksummery.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';

var httpURL = '';
var queryString = require('querystring');
var lstWorkSummary = [];
var list = [];
var sortVal = "";
var pendingCbx = "";


class WorkSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
    
            designNoColor: [],
            flg: true,
            //flgPODesign : true,
            flgStyle: true,
            deliveryDate: null,
            startDate: new Date(),
            endDate: null,
            minDate: null,
            loader: 'none',
            opacity: 1,
            width: '100%',
            flgAdd: true,
            dispReport: '',
            src: require('./../images/blank.png'),
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleChange1 = this.handleChange1.bind(this);
    }
    handleChange(date) {
        this.setState({
            startDate: date,
        });
    }
    handleChange1(date) {
        this.setState({
            endDate: date
        });
    }

    async componentDidMount() {
        var date =  new Date();
        date.setMonth(date.getMonth()-2);
      
        var endDate = new Date(date);
        endDate.setMonth( endDate.getMonth()+4);

        await this.setState({
            startDate: new Date(date),
            endDate: new Date(endDate),
            minDate: new Date(date),
            maxDate: new Date(endDate),
        })
        this.handleResize();
        window.addEventListener("load", this.handleResize);
        window.addEventListener("resize", this.handleResize);

        this.setState({ loader: 'block', opacity: 0.5 });
        this.getSummaryData();
    }

    getSummaryData = () => {
        var fromDate = $('#inp_fromDate').val();
        var toDate = $('#inp_toDate').val();

        axiosInstance.post(httpURL+'/a/ipo/worksummary/list', 
        	queryString.stringify({'fromDt':fromDate,'toDt':toDate}), {withCredentials:true}
        ).then((response)=>{	
        	if(response.data.SvcStatus === "Success"){
        			lstWorkSummary=response.data.lstWorkSummary;
                    list = lstWorkSummary;
                   
        			this.setworkSummaryTable();
        	}
        	else{
        		toast.error(response.data.SvcMsg)
        		if(response.data.SvcMsg == 'You are not logged in'){
        			window.location.href = window.WVRURL;
        			return false;
        		}
        	}
        }).catch((e)=>{
        	toast.error("Service failed "+e);
        });
    }


    setworkSummaryTable = () => {
        $('#workSummaryTableBody tr').remove();
        var table = document.getElementById('workSummaryTable');
        var tbody = document.getElementById('workSummaryTableBody');
        var filterIpo = $('#ipo').val().trim().toLowerCase();
        var filterQuality = $('#qaulityFilter').val().trim().toLowerCase();
        var filterDesignColor = $('#designColorFilter').val().trim().toLowerCase();
        var filterDeskloom = $('#deskloomFilter').val().trim().toLowerCase();
        var filterPP = $('#ppFilter').val().trim().toLowerCase();


        for (var i = 0; i < lstWorkSummary.length; i++) {
            var weaverDelDt = lstWorkSummary[i].weaverDeliveryDt;
            var ipoNo = lstWorkSummary[i].ipoNo;
            var quality = lstWorkSummary[i].quality;
            var designNoColor = lstWorkSummary[i].designNoColor;
            var quantity = lstWorkSummary[i].quantity;
            var workDone = lstWorkSummary[i].workDone;
            var yardageStatus = lstWorkSummary[i].yardageStatus;
            var balanceOffLoom = lstWorkSummary[i].balanceOffLoom;
            var balanceOnLoom = lstWorkSummary[i].balanceOnLoom;
            var deskloomStatus = lstWorkSummary[i].deskloomStatus;
            var dispatch = lstWorkSummary[i].dispatch;

            var row = document.createElement('tr');
            if (ipoNo.toLowerCase().indexOf(filterIpo) === -1)
                continue;
            if (quality.toLowerCase().indexOf(filterQuality) === -1)
            continue;
            if (designNoColor.toLowerCase().indexOf(filterDesignColor) === -1)
            continue;
            if (deskloomStatus.toLowerCase().indexOf(filterDeskloom) === -1)
            continue;
            if (yardageStatus.toLowerCase().indexOf(filterPP) === -1)
            continue;


            this.addTD(row, weaverDelDt, '');
            this.addTD(row, ipoNo, 'text-center');
            this.addTD(row, quality,'text-center');
            this.addTD(row , designNoColor , 'text-center');
            this.addTD(row, quantity, 'text-right');
            this.addTD(row, deskloomStatus, 'text-center');
            this.addTD(row, yardageStatus, 'text-center');
            this.addTD(row, workDone, 'text-right');
            this.addTD(row, dispatch, 'text-right');
            this.addTD(row, balanceOnLoom, 'text-right');
            this.addTD(row, balanceOffLoom, 'text-right');
          
    
            $(row).find("td").attr({ width: "100" });
            tbody.append(row);
        }
        table.append(tbody);
    }

    addTD(row, val, classname) {
        var cell = document.createElement('td');
        cell.className = classname;
        if (val == '-') {
            cell.style.textAlign = 'center';
        }
        var text = document.createTextNode(val);
        cell.append(text);
        row.append(cell);
    }

    handleResize = () => {
        var width1 = ($('.tableHeadReportDiv').parent().width()) - 18;
        console.log(width1)
        this.setState({ width: width1 })
    }
    

    sortAscByPo = () => {
        if (sortVal != 'aspo') {
            sortVal = 'aspo';
            $("#poAsDtIcon").css("color", "white");
            $("#poDsDtIcon").css("color", "#f1f1f1");
            $("#deliveryAsDtIcon").css("color", "#f1f1f1");
            $("#deliveryDsDtIcon").css("color", "#f1f1f1");

            var val1;
            var val2;

            for (var i = 0; i < lstWorkSummary.length - 1; i++) {
                val1 = lstWorkSummary[i].ipoNo;
                for (var j = i + 1; j < lstWorkSummary.length; j++) {
                    val2 = lstWorkSummary[j].ipoNo;
                    if (val1 > val2) {
                        var tmp = lstWorkSummary[j];
                        lstWorkSummary[j] = lstWorkSummary[i];
                        lstWorkSummary[i] = tmp;
                        val1 = lstWorkSummary[i].ipoNo;
                    }
                }
            }
            this.setworkSummaryTable();
        }
    }

    selectPending=()=>
    {
        if ($('#cbx').is(":checked"))
        {
            lstWorkSummary = [];
            for(var i=0;i<list.length;i++)
            {
                if(list[i].pendingStatus == 1)
                {
                    lstWorkSummary.push(list[i]);     
                }
            }
        }
        else
        {
            lstWorkSummary = list;
        }
        this.setworkSummaryTable();
    }


    render() {
        httpURL = window.httpURL;
        return (
            <div style={{ height: '100%' }}>
                <Header />
                <ToastContainer autoClose={2000} hideProgressBar />
                <div className="main">
                    <div className="container-fluid">
                        <div className="col-sm-12 padding-remove" style={{ overflowX: 'hidden' }}>
                            <div className="col-sm-7 workSummaryWrap col-centered" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: 10 }}>
                                <div style={{ flex: 1 }} className="text-center">
                                    <label htmlFor="inp_fromDate">From Date</label>
                                </div>
                                <div style={{ flex: 2 }} className="text-center">
                                    <DatePicker id="inp_fromDate"
                                        className='form-control text-center'
                                        placeholderText="From Date"
                                        selected={this.state.startDate}
                                        onChange={this.handleChange}
                                        dateFormat="dd-MM-yyyy"
                                        minDate={this.state.startDate}
                                        maxDate={this.state.endDate}
                                        autoComplete='off'
                                    />
                                </div>
                                <div style={{ flex: 1 }} className="text-center">
                                    <label htmlFor="inp_toDate">To Date</label>
                                </div>
                                <div style={{ flex: 2 }} className="text-center">
                                    <DatePicker id="inp_toDate"
                                        className='form-control text-center'
                                        placeholderText="To Date"
                                        selected={this.state.endDate}
                                        onChange={this.handleChange1}
                                        dateFormat="dd-MM-yyyy"
                                        minDate={this.state.startDate}
                                        maxDate={this.state.maxDate}
                                        autoComplete='off'
                                    />
                                </div>
                                <div className="pull-right">
                                    <button style={{ marginRight: 20, marginLeft: 20 }} type="button" className="btn btn-warning" onClick={this.getSummaryData} id="availability">Get Data</button>
                                </div>
                                <div className="workPendingStatus">
                                    <input type="checkbox" onChange={this.selectPending} id="cbx"/> <span className="workPending">Pending <span>(Dispatch &lt;=  97% of Quantity)</span></span> 
                                </div>
                            </div>
                            <div className="tableWorkReportDiv" style={{ width: this.state.width }}>
                                <table id="tableWorkReport" className="tableLayout1">
                                    <thead>
                                        <tr>

                                            <th style={{ width: 40, backgroundColor: "black", color: 'white' }}>Wvr Del.Dt.</th>
                                            <th style={{ width: 40, backgroundColor: "black", color: 'white' }}>
                                                <div style={{ float: 'left', width: '80%' }}>
                                                    <input type="text" onChange={this.setworkSummaryTable} className="form-control inp-search" id="ipo" placeholder="IPO" />
                                                </div>
                                                <div style={{ width: 10, float: 'left', marginLeft: 2, marginTop: 4 }}>
                                                    <div className="assending">
                                                        <span id="poAsDtIcon" onClick={this.sortAscByPo} className="glyphicon glyphicon-triangle-top"></span>
                                                    </div>
                                                    <div className="desending">
                                                        <span id="poDsDtIcon" onClick={this.sortDesByPo} className="glyphicon glyphicon-triangle-bottom"></span>
                                                    </div>
                                                </div>
                                            </th>
                                            <th style={{ width: 60, backgroundColor: "black", color: 'white' }}>
                                                <input type="text" onChange={this.setworkSummaryTable} className="form-control inp-search" id="qaulityFilter" placeholder="Quality" />
                                            </th>
                                            <th style={{ width: 60, backgroundColor: "black", color: 'white' }}>
                                                 <input type="text" onChange={this.setworkSummaryTable} className="form-control inp-search" id="designColorFilter" placeholder="DesignNoColor" />
                                            </th>
                                            <th style={{ width: 60, backgroundColor: "black", color: 'white' }}>Quantity</th>
                                            <th style={{ width: 60, backgroundColor: "black", color: 'white' }}>
                                                <input type="text" onChange={this.setworkSummaryTable} className="form-control inp-search" id="deskloomFilter" placeholder="Deskloom Status" />
                                            </th>
                                            <th style={{ width: 50, backgroundColor: "black", color: 'white' }}>
                                                <input type="text" onChange={this.setworkSummaryTable} className="form-control inp-search" id="ppFilter" placeholder="PP Yardage Status" />
                                            </th>
                                            <th style={{ width: 50, backgroundColor: "black", color: 'white' }}>Work Done</th>
                                            <th style={{ width: 50, backgroundColor: "black", color: 'white' }}>Dispatch</th>
                                            {/* <th style={{ width: 88, backgroundColor: "black", color: 'white' }}>Balance</th> */}
                                            <th className="balanceCol" style={{ width: 88, backgroundColor: "black", color: 'white', }}>
                                                <div className="balanceWrap1">Balance </div>
                                                <div className="balanceWrap">
                                                    <span className=" loom text-center onLoom"> On-loom</span>
                                                    <span className=" loom text-center">Off-loom</span>
                                                 </div>
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className="workSummaryTableDiv" onScroll={this.theadScroll}>
                                <div style={{width:'100%'}} >
                                    <table id="workSummaryTable" className="tableLayout">
                                        <colgroup>
                                            <col width="40" />
                                            <col width="40" />
                                            <col width="60" />
                                            <col width="60" />
                                            <col width="60" />
                                            <col width="60" />
                                            <col width="50" />
                                            <col width="50" />
                                            <col width="50" />
                                            <col width="40" />
                                            <col width="40" />
                                        </colgroup>
                                        <tbody id="workSummaryTableBody"></tbody>
                                    </table>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WorkSummary;
